export default __webpack_public_path__ + "static/media/gallery_f-min.b45adbda.jpg";